<script lang="ts">
import LayoutReportStep from "@/layouts/LayoutReportStep.vue";
import { IReportStep } from "@/lib/interfaces/Report/IViewReportStep";
import { ReportScreenEnum } from "@/store/enum/partner/report-screen.enum";
import { Component } from "vue-property-decorator";
import ReportSummary from "./ReportSummary.vue";
import { ReportModule } from "@/store/modules/report.store";

@Component({
  components: {
    LayoutReportStep
  }
})
export default class ReportSummaryAuth extends ReportSummary implements IReportStep {
  screen = ReportScreenEnum.closingauth;

  mounted() {
    ReportModule.setPrivacyCheck(true);
  }

  get isDone() {
    return this.valid;
  }
}
</script>

<style scoped>
.text {
  color: rgba(0, 0, 0, 0.6);
}
</style>
